import React, { useEffect } from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { colores, fuentes } from '../../../styles/variablesCss';
import { clearPendingPurchase } from '../../../utils/analytics';

const PagoFail = ({ navigation }) => {
  // Si se carga dentro de un iframe (respuesta del gateway), avisar al parent
  useEffect(() => {
    try {
      clearPendingPurchase();
      if (typeof window !== 'undefined' && window.parent && window.parent !== window) {
        window.parent.postMessage({ type: 'IPG_RESULT', status: 'fail' }, '*');
        // Limpia el contenido del iframe para que no muestre esta página
        setTimeout(() => {
          try { window.location.replace('about:blank'); } catch (e) {}
        }, 0);
      }
    } catch (e) {
      // ignore
    }
  }, []);

  const goBackToCheckout = () => {
    if (navigation && navigation.navigate) {
      navigation.navigate('CheckoutFinalizarCompra');
    } else if (typeof window !== 'undefined') {
      window.location.href = '/checkout';
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        {/* Icono de error */}
        <View style={styles.iconContainer}>
          <MaterialCommunityIcons 
            name="close-circle-outline" 
            size={100} 
            color={colores.rojo} 
          />
        </View>

        {/* Título principal */}
        <Text style={styles.title}>El pago no pudo completarse</Text>

        {/* Descripción */}
        <Text style={styles.description}>
          Lo sentimos, hubo un problema al procesar tu pago. Por favor, intenta nuevamente o elige otro medio de pago.
        </Text>

        {/* Información adicional */}
        <View style={styles.infoBox}>
          <MaterialCommunityIcons 
            name="information-outline" 
            size={20} 
            color={colores.rojo}
            style={styles.infoIcon}
          />
          <Text style={styles.infoText}>
            Tu dinero no ha sido debitado. Puedes intentar con otra tarjeta o método de pago.
          </Text>
        </View>

        {/* Botón principal */}
        <TouchableOpacity 
          style={styles.button}
          onPress={goBackToCheckout}
          activeOpacity={0.8}
        >
          <MaterialCommunityIcons 
            name="arrow-left" 
            size={20} 
            color={colores.blanco}
            style={styles.buttonIcon}
          />
          <Text style={styles.buttonText}>Volver al Checkout</Text>
        </TouchableOpacity>

        {/* Botón secundario */}
        <TouchableOpacity 
          style={styles.secondaryButton}
          onPress={() => navigation.navigate('Home')}
        >
          <Text style={styles.secondaryButtonText}>Ir al Inicio</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
    paddingHorizontal: 20,
  },
  content: {
    alignItems: 'center',
    maxWidth: 500,
    width: '100%',
  },
  iconContainer: {
    marginBottom: 25,
    opacity: 0.95,
  },
  title: {
    fontSize: 28,
    fontFamily: fuentes.bold,
    color: colores.rojo,
    marginBottom: 15,
    textAlign: 'center',
  },
  description: {
    fontSize: 16,
    fontFamily: fuentes.regular,
    color: '#666',
    textAlign: 'center',
    marginBottom: 25,
    lineHeight: 24,
  },
  infoBox: {
    backgroundColor: 'rgba(230, 33, 35, 0.08)',
    borderLeftWidth: 4,
    borderLeftColor: colores.rojo,
    paddingVertical: 15,
    paddingHorizontal: 15,
    borderRadius: 6,
    marginBottom: 30,
    flexDirection: 'row',
    alignItems: 'flex-start',
    width: '100%',
  },
  infoIcon: {
    marginRight: 12,
    marginTop: 2,
  },
  infoText: {
    fontSize: 14,
    fontFamily: fuentes.regular,
    color: '#555',
    flex: 1,
    lineHeight: 20,
  },
  button: {
    backgroundColor: colores.rojo,
    paddingVertical: 14,
    paddingHorizontal: 40,
    borderRadius: 8,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 12,
    width: '100%',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.15,
    shadowRadius: 4,
    elevation: 3,
  },
  buttonIcon: {
    marginRight: 10,
  },
  buttonText: {
    color: colores.blanco,
    fontSize: 16,
    fontFamily: fuentes.bold,
  },
  secondaryButton: {
    paddingVertical: 12,
    paddingHorizontal: 30,
    borderRadius: 8,
    borderWidth: 2,
    borderColor: colores.rojo,
  },
  secondaryButtonText: {
    color: colores.rojo,
    fontSize: 14,
    fontFamily: fuentes.semiBold,
  },
});

export default PagoFail;
